import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./menuMainSection.css";

import Loader from "../commonComponents/Loader/Loader";
import { toast } from "react-toastify";
import { useAuth } from "../../contexts/AuthContext";

export default function MainCategories() {
  const [products, setProducts] = useState([]);
  const { currentUser } = useAuth();

  useEffect(() => {
    fetch("https://api.redfoxcafe.ir/v1/main/products/", {
      method: "GET",
      headers: {
        "Authorization-Token":
          "Bearer " + (currentUser ? currentUser.access_token : ""),
      },
    })
      .then((response) => response.json())
      .then((d) => {
        setProducts(d.data);
      });
  }, [currentUser]);

  const categories = products.map((val) => {
    return (
      <Link
        to={`/shop?category=${val.MainCatInEnglish}`}
        className="main-category"
      >
        {val.MainCatName}
      </Link>
    );
  });

  return (
    <div className="menu-container upper-container">
      {products.length === 0 ? (
        <Loader />
      ) : (
        <div className="main-category-selector">
          <div className="cafe-name-logo">
            <span className="cafe-name">RED FOX</span>
            <span className="cafe-name-desc">Coffee Shop</span>
          </div>
          <div className="main-categories">{categories}</div>
        </div>
      )}
    </div>
  );
}
